// extracted by mini-css-extract-plugin
export default {"container":"App_container__JIL7C","image":"App_image__xoAZv"};